import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import { AccordionNav } from "./navigation/AccordionNav";
import { SearchBox } from  "./site/SearchBox"
import { SearchPulldown } from './site/SearchPulldown';
import ReadMore from './site/ReadMore';
import { Video } from './site/Video';
import sortBy from './site/sortBy';
import responsiveIframe from './site/responsiveIframe';
import googleCalendar from './site/googleCalendar';
import newTabLinks from './site/newTabLinks';
import handleFlyoutMenu from './site/handleFlyoutMenu';
import slickCarousel from '../../node_modules/slick-carousel';
import slickInit from './site/slickInit';
import slickExtend from './site/slickExtend';

svg4everybody();

let accordionNav = new AccordionNav($('.js-accordion-nav'));
let searchBoxes = $('.js-search-box').map( (idx, el) =>  {
  return new SearchBox($(el));
});

let searchPulldown = new SearchPulldown($('.global-top .js-search-toggle'));

let readMoreFaqs = $('.js-c-faqs__answer').map( (index, element) => {
  return ReadMore($(element), 'Read More', 'Read Less', '...');
});

let playVideo = $('.js-c-video__play-button').map( (index, element) => {
  return new Video($(element));
});

sortBy();
responsiveIframe();
googleCalendar();
newTabLinks('a');
handleFlyoutMenu('js-primary-nav', 'js-has-submenu', 'primary-nav__submenu', 'primary-nav__submenu-list', 'Home');
handleFlyoutMenu('js-utility-nav', 'js-utility-item.has-submenu', 'global-top__submenu', 'global-top__submenu-group', 'Home');
// handleFlyoutMenu('global-top__buttons', 'js-nav-toggle.has-submenu', 'global-top-buttons__submenu', 'global-top__submenu-group', 'Home');
slickInit();
slickExtend();